import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperVotePage } from './shopper-vote';

@NgModule({
  declarations: [
    ShopperVotePage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperVotePage),
    TranslateModule.forChild()
  ],
})
export class ShopperVotePageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-vote/shopper-vote.module.ts